import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import WhiteCard from "src/shared/components/WhiteCard";
import SlotPicker from "../SlotPicker";
import { useGetTimeSlotsQuery } from "src/api/services/encounterApi";
import { Specialties } from "src/api/types";
import { usePatient } from "src/context/PatientProvider";
import { skipToken } from "@reduxjs/toolkit/query";

const RequestSyncVisit = () => {
  const specialty: Specialties = "General";
  const region = usePatient((p) => p.profile.region);
  const { data } = useGetTimeSlotsQuery(
    region
      ? {
          specialty,
          state: region,
        }
      : skipToken,
  );

  console.log({ data, region });

  const { t } = useTranslation();

  if (data == null) {
    return null;
  }

  return (
    <WhiteCard
      direction={"row"}
      gap={1}
      alignItems={"center"}
      justifyContent={"space-between"}
    >
      <Stack>
        <Typography variant="h6" fontWeight={700}>
          {t("request-sync-visit.title", "See provider now")}
        </Typography>
        <Typography>
          {t(
            "request-sync-visit.description",
            "Connect with a provider in minutes",
          )}
        </Typography>
      </Stack>
      {/* <Button onClick={handleRequestSyncVisit}>
        {t("request-sync-visit.button", "Now")}
      </Button> */}
      <SlotPicker availability={data} />
    </WhiteCard>
  );
};

export default RequestSyncVisit;
